import type CreateRelationInput from "../domain/relation";
import {
  createRelationAPI,
  deleteRelationAPI,
  fetchRelationTypesAPI,
  fetchRelationsAPI,
  updateRelationAPI,
} from "../infrastructure/relation.api";
import type { Relation, RelationType } from "../infrastructure/relation.formatter";

export async function createRelation(
  referenceId: string,
  input: CreateRelationInput,
): Promise<void> {
  await createRelationAPI(referenceId, input);
}

export async function fetchRelations(referenceId: number): Promise<Relation[]> {
  return await fetchRelationsAPI(referenceId);
}

export async function updateRelation(
  referenceId: string,
  tableId: string,
  input: CreateRelationInput,
): Promise<void> {
  await updateRelationAPI(referenceId, tableId, input);
}

export async function deleteRelation(referenceId: number, relationId: number): Promise<void> {
  await deleteRelationAPI(referenceId, relationId);
}

export async function fetchRelationTypes(): Promise<RelationType | undefined> {
  return await fetchRelationTypesAPI();
}
